<template>
  <a class="df-nav-item" v-if="href" :href="href" :target="target || '_self'">
    <img class="df-nav-item__prefix-icon" v-if="prefixIcon" :src="prefixIcon"/>
    <slot></slot>
    <img class="df-nav-item__suffix-icon" v-if="suffixIcon" :src="suffixIcon"/>
  </a>
  <span class="df-nav-item" v-else @click="$emit('click', $event)">
    <img class="df-nav-item__prefix-icon" v-if="prefixIcon" :src="prefixIcon"/>
    <slot></slot>
    <img class="df-nav-item__suffix-icon" v-if="suffixIcon" :src="suffixIcon"/>
  </span>
</template>

<script>
export default {
  name: "df-nav-item",
  props: ['prefixIcon', 'suffixIcon', 'href', 'target']
};
</script>

<style lang="less" scoped>
.df-nav-item {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 20px;
  display: flex;
  align-items: center;
  &__prefix-icon {
    margin-right: 3px;
  }
  &__suffix-icon {
    margin-left: 3px;
  }
}
img {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
</style>
